// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  background: var(--ion-color-white);
  height: 100%;
  overflow: auto;
  padding: 45px 15px 25px;
}
.wrapper.eintracht {
  background: #282828;
  color: var(--ion-color-white);
}
.wrapper.eintracht .title {
  color: var(--ion-color-white);
}
.wrapper.eintracht .info_block p {
  color: var(--ion-color-black);
}
.wrapper.eintracht ion-button {
  --background: #E30613;
  --border-width: 0px;
  --border-radius: 6px;
}
.wrapper ion-img {
  width: 50px;
}
.wrapper .title {
  font-size: 32px;
  font-weight: 700;
  line-height: 120%;
  vertical-align: middle;
  text-transform: capitalize;
  color: var(--ion-color-black);
  margin-bottom: 25px;
}
.wrapper .cross {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 22px;
  width: 22px;
  padding: 3px;
}
.wrapper ul {
  list-style-type: none;
  padding: 0px;
  padding-bottom: 50px;
}
.wrapper li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
}
.wrapper li .item-wrapper {
  padding: 12px 15px;
  background: #fff;
  margin-bottom: 5px;
  width: 100%;
  border: 1px solid #e8e8df;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 992px) {
  .wrapper li .item-wrapper {
    padding-block: 9px;
  }
}
.wrapper li .item-wrapper .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
.wrapper li .item-wrapper .info_block p {
  font-family: AppFont;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
}
.wrapper li .item-wrapper .info_block ion-img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}
.wrapper li .item-wrapper .circle {
  width: 20px;
  height: 20px;
  content: " ";
  border: 1px solid rgba(112, 113, 115, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.wrapper li .item-wrapper .circle .cirle_inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 13.2px;
  height: 13.2px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
.wrapper li .item-wrapper .circle .cirle_inner.selected {
  background: var(--ion-color-black);
  transition: ease-in-out 0.3s;
}
.wrapper .line-border {
  padding: 0px 20px;
}
.wrapper .line-border ion-icon {
  fill: white;
  width: 100%;
}
.wrapper .footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px 15px;
  display: flex;
  justify-content: center;
}
.wrapper .footer-item ion-button {
  font-family: var(--ion-font-family);
  width: 100%;
  text-transform: capitalize;
  font-size: 16px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-language-modal/select-language-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACC,WAAA;EACA,kCAAA;EAEA,YAAA;EACA,cAAA;EACA,uBAAA;AALD;AAOC;EACC,mBAAA;EACA,6BAAA;AALF;AAME;EACC,6BAAA;AAJH;AAOG;EACA,6BAAA;AALH;AAQE;EACC,qBAAA;EACA,mBAAA;EACA,oBAAA;AANH;AAUA;EACC,WAAA;AARD;AAWA;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;EACA,mBAAA;AATD;AAYA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAVD;AAaA;EACC,qBAAA;EACA,YAAA;EACA,oBAAA;AAXD;AAaA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,qBAAA;AAZD;AAcC;EACC,kBAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAdF;ACxDE;ED2DD;IAcE,kBAAA;EAbD;AACF;AAcE;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;AAZH;AAaG;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AAXJ;AAaG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAXJ;AAcE;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAZH;AAmBG;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,aAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AAlBJ;AAoBI;EACC,kCAAA;EACA,4BAAA;AAlBL;AAwBA;EACC,iBAAA;AAtBD;AAuBC;EACC,WAAA;EACA,WAAA;AArBF;AAwBA;EACC,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAtBD;AAuBC;EACC,mCAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;AArBF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n}\n\n.wrapper {\n\twidth: 100%;\n\tbackground: var(--ion-color-white);\n\t// box-shadow: 0px 4px 10px 0px #00000008;\n\theight: 100%;\n\toverflow: auto;\n\tpadding: 45px 15px 25px;\n\n\t&.eintracht {\n\t\tbackground: #282828;\n\t\tcolor: var(--ion-color-white);\n\t\t.title {\n\t\t\tcolor: var(--ion-color-white);\n\t\t}\n\t\t.info_block { \n\t\t\tp {\n\t\t\tcolor: var(--ion-color-black);\n\t\t}\n\t\t}\n\t\tion-button {\n\t\t\t--background: #E30613;\n\t\t\t--border-width: 0px;\n\t\t\t--border-radius: 6px;\n\t\t}\t\n}\n\nion-img {\n\twidth: 50px;\n}\n\n.title {\n\tfont-size: 32px;\n\tfont-weight: 700;\n\tline-height: 120%;\n\tvertical-align: middle;\n\ttext-transform: capitalize;\n\tcolor: var(--ion-color-black);\n\tmargin-bottom: 25px;\n}\n\n.cross {\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n\theight: 22px;\n\twidth: 22px;\n\tpadding: 3px;\n}\n\nul {\n\tlist-style-type: none;\n\tpadding: 0px;\n\tpadding-bottom: 50px;\n}\nli {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\ttext-decoration: none;\n\n\t.item-wrapper {\n\t\tpadding: 12px 15px;\n\t\tbackground: #fff;\n\n\t\tmargin-bottom: 5px;\n\n\t\twidth: 100%;\n\t\tborder: 1px solid #e8e8df;\n\t\tborder-radius: 9px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n\t\t@include mobile {\n\t\t\tpadding-block: 9px;\n\t\t}\n\t\t.info_block {\n\t\t\tborder-radius: 20px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tp {\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 120%;\n\t\t\t\tletter-spacing: 0%;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t}\n\t\t\tion-img {\n\t\t\t\twidth: 26px;\n\t\t\t\theight: 26px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\toverflow: hidden;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t\t.circle {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tcontent: ' ';\n\t\t\tborder: 1px solid #70717399;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tposition: relative;\n\n\t\t\t// &:has(.selected) {\n\t\t\t// \tborder: 2px solid var(--ion-color-black);\n\t\t\t// \tbackground: transparent;\n\t\t\t// }\n\n\t\t\t.cirle_inner {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translate(-50%, -50%);\n\n\t\t\t\twidth: 13.2px;\n\t\t\t\theight: 13.2px;\n\t\t\t\tcontent: ' ';\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder-radius: 50%;\n\n\t\t\t\t&.selected {\n\t\t\t\t\tbackground: var(--ion-color-black);\n\t\t\t\t\ttransition: ease-in-out 0.3s;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.line-border {\n\tpadding: 0px 20px;\n\tion-icon {\n\t\tfill: white;\n\t\twidth: 100%;\n\t}\n}\n.footer-item {\n\tposition: fixed;\n\tleft: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tpadding: 20px 15px;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t\tfont-family: var(--ion-font-family);\n\t\twidth: 100%;\n\t\ttext-transform: capitalize;\n\t\tfont-size: 16px;\n\t\tfont-weight: 700;\n\t}\n}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
